import {css, StyleSheet} from "aphrodite";
import React from 'react';
import WhatsNewAreaUtils from "./WhatsNewAreaUtils";
import Config from "../../config/Config";
import GridStyles from "../../styles/styles";
import MediaQuery from "../../styles/MediaQuery";
import TextDiv from "../containers/TextDiv";
import FeedbackButton from "../FeedbackButton";
import Image from "../containers/Image";

const WhatsNewAreaDesktop = ({extraStyle}) => {
    const styles = StyleSheet.create({
            container: {
                ...GridStyles.define("80px max-content 54px", "minmax(20px, auto) 1fr minmax(20px, auto)"),
                backgroundImage: `url(${Config.images.HEADER_A})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                justifyContent: "center",
                ...MediaQuery.dynamic(1024, {
                    backgroundImage: `url(${Config.images.HEADER_A_MOBILE_1020})`
                })
            },
            wrapper: {
                ...GridStyles.setRowCol(2, 2),
                ...GridStyles.define("auto", "minmax(200px, 480px) 37px minmax(200px, 540px)"),
                justifyContent: "center"
            },
            textArea: {
                ...GridStyles.setRowCol(1, 1),
                ...GridStyles.define("max-content 11px max-content 30px max-content 12px max-content", "auto"),
                color: Config.colors.SECONDARY_TEXT
            },
            image: {
                ...GridStyles.setRowCol(1, 3),
                maxWidth: 540,
                maxHeight: 350,
                width: "100%",
                height: "auto"
            },
            title: {
                ...GridStyles.setRowCol(1, 1),
                fontSize: 56,
                lineHeight: 1.07,
                fontWeight: "bold"
            },
            description: {
                ...GridStyles.setRowCol(3, 1),
                fontSize: 16,
                lineHeight: 1.75
            },
            button: {
                ...GridStyles.setRowCol(5, 1),
                ...MediaQuery.mobile({
                    margin: "0 auto"
                })
            },
            headerDownload: {
                ...GridStyles.setRowCol(7, 1),
                fontSize: 13,
                fontWeight: "bold",
                lineHeight: 1.85,
                "> a": {
                    color: "white"
                }
            }
        }),
        downloadText = WhatsNewAreaUtils.getDownloadText();

    return (
        <div className={css(styles.container, extraStyle)}>
            <div className={css(styles.wrapper)}>
                <div className={css(styles.textArea)}>
                    <TextDiv extraStyle={styles.title} text={Config.messages.switchYourBrowser}/>
                    <TextDiv extraStyle={styles.description} text={Config.messages.switchYourBrowserSub}/>
                    <FeedbackButton extraStyle={styles.button}/>
                    <TextDiv text={downloadText} extraStyle={styles.headerDownload}/>
                </div>
                <Image extraStyle={styles.image} src={Config.images.SWITCH}/>
            </div>
        </div>
    );
};

export default WhatsNewAreaDesktop;
